var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271.252,
    height: 221.148,
    viewBox: "0 0 271.252 221.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M268.079,221.148H3.175a3.18,3.18,0,0,1-3-4.22L55.569,56.592a3.18,3.18,0,0,1,3-2.139H91.165V30.845A30.8,30.8,0,0,1,121.983,0h27.288a30.513,30.513,0,0,1,11.993,2.423,30.833,30.833,0,0,1,18.82,28.422V54.453h32.594a3.183,3.183,0,0,1,3.007,2.139l55.393,160.336a3.18,3.18,0,0,1-3,4.22ZM152.293,110.574v12.588H171.64V181.9h15.107v-58.74h19.347V110.574ZM127.976,126.04c-.386,8.892-.608,14.473-.658,16.588-.049,2.089-.074,3.944-.074,5.513V181.9h14.084V110.574H120.763l-17.885,54.545h-.291L85.725,110.574H65.16V181.9h13.5V148.726c0-3.794-.311-11.46-.925-22.784h.439L95.326,181.9h13.84l18.371-55.862h0ZM125.782,17.453a16.791,16.791,0,0,0-16.763,16.781V51.79a16.825,16.825,0,0,0,.214,2.667h52.789a17.112,17.112,0,0,0,.211-2.667V34.234a16.788,16.788,0,0,0-16.756-16.781Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.163561189decd5b6a35835da193cbdc0.svg";
export { ForwardRef as ReactComponent };